import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { IAuthentication, IAuthorization } from './auth.models';

@Injectable()
export class AuthService {
    private _http = inject(HttpClient);

    public getAuthorizationApi = (): Observable<IAuthorization> => this._http.get<IAuthorization>(`users/authorization`);

    public getAuthenticationApi = (): Observable<IAuthentication> => this._http.get<IAuthentication>(`users/authentication`);
}
